<template>
    <b-container>
        <b-row align-v="stretch" align-h="center" class="my-4 text-center">
            <b-col cols="6" sm="4" md="3" class="pb-3">
                <b-card class="shadow border-0 h-100 cursor-pointer" @click="getLink('CheckerApproved')">
                    <div class="avatar avatar-60 no-shadow border-0">
                        <div class="overlay bg-template"></div>
                        <i class="material-icons vm md-36 text-template">paid</i>
                    </div>
                    <h3 class="mt-3 mb-0 font-weight-normal">{{ statistics.completed }}</h3>
                    <p class="text-secondary text-mute small">Transacciones Completadas</p>
                </b-card>
            </b-col>
            <b-col cols="6" sm="4" md="3" class="pb-3">
                <b-card class="shadow border-0 h-100 cursor-pointer" @click="getLink('CheckerPending')">
                    <div class="avatar avatar-60 no-shadow border-0">
                        <div class="overlay bg-template"></div>
                        <i class="material-icons vm md-36 text-template">pending</i>
                    </div>
                    <h3 class="mt-3 mb-0 font-weight-normal">{{ statistics.pending }}</h3>
                    <p class="text-secondary text-mute small">Confirmación Pendiente</p>
                </b-card>
            </b-col>
            <b-col cols="6" sm="4" md="3" class="pb-3">
                <b-card class="shadow border-0 h-100 cursor-pointer" @click="getLink('ReportPending')">
                    <div class="avatar avatar-60 no-shadow border-0">
                        <div class="overlay bg-template"></div>
                        <i class="material-icons vm md-36 text-template">change_circle</i>
                    </div>
                    <h3 class="mt-3 mb-0 font-weight-normal">{{ statistics.others }}</h3>
                    <p class="text-secondary text-mute small">Otras Pendientes</p>
                </b-card>
            </b-col>
            <b-col cols="6" sm="4" md="3" class="pb-3">
                <b-card class="shadow border-0 h-100 cursor-pointer" @click="getLink('ReportGeneral')">
                    <div class="avatar avatar-60 no-shadow border-0">
                        <div class="overlay bg-template"></div>
                        <i class="material-icons vm md-36 text-template">insights</i>
                    </div>
                    <h3 class="mt-3 mb-0 font-weight-normal">{{ statistics.total }}</h3>
                    <p class="text-secondary text-mute small">Total Transacciones</p>
                </b-card>
            </b-col>
            <b-col cols="6" sm="4" md="3" class="pb-3">
                <b-card class="shadow border-0 h-100 cursor-pointer" @click="getLink('Customers')">
                    <div class="avatar avatar-60 no-shadow border-0">
                        <div class="overlay bg-template"></div>
                        <i class="material-icons vm md-36 text-template">people_alt</i>
                    </div>
                    <h3 class="mt-3 mb-0 font-weight-normal">{{ statistics.customers }}</h3>
                    <p class="text-secondary text-mute small">Clientes Registrados</p>
                </b-card>
            </b-col>
            <b-col cols="6" sm="4" md="3" class="pb-3">
                <b-card class="shadow border-0 h-100 cursor-pointer" @click="getLink('Partners')">
                    <div class="avatar avatar-60 no-shadow border-0">
                        <div class="overlay bg-template"></div>
                        <i class="material-icons vm md-36 text-template">store</i>
                    </div>
                    <h3 class="mt-3 mb-0 font-weight-normal">{{ statistics.partners }}</h3>
                    <p class="text-secondary text-mute small">Oficinas Agentes</p>
                </b-card>
            </b-col>
            <b-col cols="6" sm="4" md="3" class="pb-3">
                <b-card class="shadow border-0 h-100 cursor-pointer" @click="getLink('OpenTickets')">
                    <div class="avatar avatar-60 no-shadow border-0">
                        <div class="overlay bg-template"></div>
                        <i class="material-icons vm md-36 text-template">support</i>
                    </div>
                    <h3 class="mt-3 mb-0 font-weight-normal">{{ statistics.claims }}</h3>
                    <p class="text-secondary text-mute small">Reclamos Abiertos</p>
                </b-card>
            </b-col>
            <b-col cols="6" sm="4" md="3" class="pb-3">
                <b-card class="shadow border-0 h-100 cursor-pointer" @click="getLink('PartnerBalance')">
                    <div class="avatar avatar-60 no-shadow border-0">
                        <div class="overlay bg-template"></div>
                        <i class="material-icons vm md-36 text-template">receipt_long</i>
                    </div>
                    <h3 class="mt-3 mb-0 font-weight-normal">{{ statistics.balance }}</h3>
                    <p class="text-secondary text-mute small">Prefondeo Pendiente</p>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "AdminHome",
    props: [ 'user' ],
    data: () => ({
        loading: true,
        statistics: {
            pending: 0,
            others: 0,
            customers: 0,
            completed: 0,
            total: 0,
            partners: 0,
            claims: 0,
            balance: 0
        }
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'homepage');
        this.getIni();
    },
    methods: {
        getIni() {
            axios.get('/api/admin/home').then((res) => {
                if (res.data.status === 'success') {
                    this.statistics = res.data.statistics;
                    this.$emit('success');
                } else {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
            });
            this.timeout = setTimeout(this.getIni, 120000);
        },
        getLink(route) {
            this.$router.push({ name: route });
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>

</style>
